const UNIVERSITY_INFORMATION = [
	'job_prospects',
	'courses_lectures',
	'accommodation',
	'city_life',
	'student_support',
];

const CAMPUS_LIFE = [
	'student_life',
	'university_facilities',
	'clubs_societies',
	'student_union',
];
const TUITION_FEES = ['tuition_fees', 'scholarships_bursaries'];

const UNI_SECTION_KEY_LIST = {
	// [Uni Name] key information
	job_prospects: 'Job Prospects',
	courses_lectures: 'Courses and Lectures',
	accommodation: 'Accommodation',
	city_life: 'City Life',
	student_support: 'Student Support',
	//Campus life
	student_life: 'Student Life',
	university_facilities: 'University Facilities',
	clubs_societies: 'Clubs and Societies',
	student_union: "Students' Union",
	// Tuition Fees
	tuition_fees: 'Tuition Fees',
	scholarships_bursaries: 'Scholarships and Bursaries',
};

export { UNIVERSITY_INFORMATION, CAMPUS_LIFE, TUITION_FEES, UNI_SECTION_KEY_LIST };
